export const filterInfo = state => state.filterInfo
export const courseRichContent = state => state.courseRichContent
export const assistantStoreInfo = state => state.assistantStoreInfo
export const classRequestParams = state => state.classRequestParams
